var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs } from "theme-ui/jsx-runtime";
import * as st from './styles';
export var Breadcrumbs = function (_a) {
    var crumbs = _a.crumbs, isBlackFriday = _a.isBlackFriday;
    var breadcrumbsItemStyles = st.breadcrumbsItem(isBlackFriday);
    var breadcrumbsLinkStyles = st.breadcrumbsLink(isBlackFriday);
    return (_jsxs("ul", __assign({ sx: st.breadcrumbs }, { children: [_jsx("li", __assign({ sx: breadcrumbsItemStyles }, { children: _jsx("a", __assign({ href: "/", sx: breadcrumbsLinkStyles }, { children: "Uswitch.com" })) })), crumbs.map(function (_a) {
                var name = _a.name, link = _a.link;
                return (_jsx("li", __assign({ sx: breadcrumbsItemStyles }, { children: link ? (_jsx("a", __assign({ href: link, sx: breadcrumbsLinkStyles }, { children: name }))) : (_jsx("span", { children: name })) }), name));
            })] })));
};
//# sourceMappingURL=index.js.map